const bannerRighSide = () => {
    if ($(".banner-right-side").length == 0) return;
    initSlide();
    $(window).on('resize', function () {
        initSlide();
    })
}
let isSlick = false;
const initSlide = () => {
    if ($(window).width() < 1024) {
        if (isSlick) return;
        isSlick = true;
        $(".banner-right-side .banner-list").slick({
            dots: false,
            infinite: false,
            speed: 500,
            cssEase: 'linear',
            autoplay: false,
            autoplaySpeed: 5000,
            centerMode: false,
            slidesToShow: 3,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        autoplay: false,
                        centerMode: true,
                        arrows: false,
                    }
                },
            ]

        });
    }
    else {
        if (!isSlick) return;
        isSlick = false;
        setTimeout(() => {
            $(".banner-right-side .banner-list").slick('unslick');
        }, 100)
    }
}
module.exports = bannerRighSide